const redirectToLogin = (currentPagePath) => {
  localStorage.removeItem('pageBeforeLogin');
  localStorage.setItem('pageBeforeLogin', currentPagePath)
  window.location = '/login';
}

export default redirectToLogin